import { merge } from 'lodash-es';
import { CHART_TYPES } from '../enums.js';
import { getVar } from './builder-helpers.js';

const sparklineConfigBuilder = (config, chartJSConfig) => {
  const sparklineBorderWidth = 2;
  const isSparkline = config.series.every(({ seriesType }) => {
    return seriesType === CHART_TYPES.SPARKLINE.toUpperCase();
  });

  if (!isSparkline) {
    return chartJSConfig;
  }

  const configObject = {
    options: {
      scales: {
        x: {
          display: false,
        },
        y: {
          display: false,
          min: ctx => Math.min(...ctx.chart.data.datasets.flatMap(d => d.data)),
          max: ctx => Math.max(...ctx.chart.data.datasets.flatMap(d => d.data)),
        },
      },
      plugins: {
        tooltip: {
          enabled: false,
        },
      },
      interaction: {
        mode: null,
      },
    },
  };

  chartJSConfig.data.datasets = chartJSConfig.data.datasets.map(dataset => {
    return {
      ...dataset,
      borderWidth: sparklineBorderWidth,
      borderColor: getVar('--fc-color-text-secondary'),
      type: CHART_TYPES.LINE,
      clip: false,
    };
  });

  return merge(chartJSConfig, configObject);
};

export default sparklineConfigBuilder;
